<template>
<div class="chapter">
<div class="inner_page">
<h1>The War Trail</h1>
<h3 class="sigil_not_in_toc">The Hunt of the Wild Horse</h3>
<h2 class="sigil_not_in_toc">Thomas Mayne Reid</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?016b24c4